import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
const Header = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div className=" ">

    
    <div className="container">
      <div className="header">
        <div>
          <img src="/assets/images/Logo.svg" alt="Logo" />
        </div>
        <ul className="d-none d-lg-block">
          <li>
            <a href="#about">About</a>
          </li>
          <li>
            <a href="#feature">Features</a>
          </li>
        
          <li>
            <a href="#how-its-work">How It Works</a>
          </li>
          <li>
            <a href="#token">PHARMA Token</a>
          </li>
          <li>
            <a href="#road-map">Roadmap</a>
          </li>
        </ul>

        <div className="d-none d-lg-block">
          {/* <a href="#contact">
            <button className="outline-btn">Contact</button>
          </a> */}
        </div>
        <div
          style={{ cursor: "pointer" }}
          className="d-block d-lg-none"
          onClick={handleShow}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            style={{ fill: "black" }}
          >
            <path d="M 3 5 A 1.0001 1.0001 0 1 0 3 7 L 21 7 A 1.0001 1.0001 0 1 0 21 5 L 3 5 z M 3 11 A 1.0001 1.0001 0 1 0 3 13 L 21 13 A 1.0001 1.0001 0 1 0 21 11 L 3 11 z M 3 17 A 1.0001 1.0001 0 1 0 3 19 L 21 19 A 1.0001 1.0001 0 1 0 21 17 L 3 17 z"></path>
          </svg>
        </div>
      </div>
      <Offcanvas show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {" "}
            <div>
              <img src="/assets/images/Logo.svg" alt="Logo" />
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul className="mobile-canvas">
            <li>
              <a href="#about" onClick={handleClose}>About</a>
            </li>
            <li>
              <a href="#feature" onClick={handleClose}>Features</a>
            </li>
            <li>
              <a href="#how-its-work" onClick={handleClose}>How It Works</a>
            </li>
            <li>
              <a href="#token" onClick={handleClose}>PHARMA Token</a>
            </li>
          
          
            <li>
              <a href="#road-map" onClick={handleClose}>Roadmap</a>
            </li>
            <li>
              {" "}
              {/* <div>
                <a href="#contact"  onClick={handleClose} >
                  <button  className="outline-btn">Contact</button>
                </a>
              </div> */}
            </li>
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
    </div>
  );
};

export default Header;
